import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import Switch from "../../../components/Switch/Switch";

export const tableConstants = (permissions, onToggle, togglingKeys, onEdit) => [
  {
    title: "SNo",
    render: (_rowData, rowIndex) => <span>{rowIndex + 1}</span>,
  },
  {
    title: "Key",
    render: (rowData) => (
      <span className="paf-key-badge">{rowData.key}</span>
    ),
  },
  {
    title: "Feature Name",
    render: (rowData) => <span className="fw-semibold">{rowData.name}</span>,
  },
  {
    title: "Description",
    render: (rowData) => (
      <span className="text-muted" style={{ fontSize: "13px" }}>
        {rowData.description || "-"}
      </span>
    ),
  },
  {
    title: "Default Status",
    render: (rowData) => (
      <span
        className={`badge ${rowData.is_enabled_by_default ? "bg-success" : "bg-secondary"}`}
      >
        {rowData.is_enabled_by_default ? "Enabled" : "Disabled"}
      </span>
    ),
  },
  {
    title: "Org Status",
    render: (rowData) => {
      const isToggling = togglingKeys.has(rowData.key);
      const isEnabled =
        rowData.is_enabled !== undefined && rowData.is_enabled !== null
          ? rowData.is_enabled
          : rowData.is_enabled_by_default;

      return (
        <div
          className="paf-toggle-wrap"
          style={{ opacity: isToggling ? 0.5 : 1 }}
        >
          {isToggling && (
            <span
              className="spinner-border spinner-border-sm me-2 text-primary"
              role="status"
              aria-hidden="true"
            />
          )}
          <Switch
            id={`paf-toggle-${rowData.key}`}
            name={`paf-toggle-${rowData.key}`}
            label={isEnabled ? "Enabled" : "Disabled"}
            checked={!!isEnabled}
            value={rowData.key}
            disabled={isToggling}
            onChange={() => onToggle(rowData)}
          />
        </div>
      );
    },
  },
  {
    title: "Action",
    render: (rowData) => (
      <span>
        {permissions.includes("parent.app.feature.update") && (
          <FontAwesomeIcon
            icon={faEdit}
            style={{ color: "var(--color-primary-text)", cursor: "pointer" }}
            onClick={() => onEdit(rowData)}
          />
        )}
      </span>
    ),
  },
];
